import { MoovFileDTO } from "../DTO/moovFileDTO";

export class MoovFile{
    public id!: number;
    public customerId!: number;
    public originalFilename!: string;
    public externalFilename!: string;
    public filepath!: string;
    public lineCount!: number;
    public purgeAfter!: Date;
    public purgedAt!: Date;
    public added!: Date;
    

    public static mapFromDTO(param:MoovFileDTO):MoovFile{ 
        if (!param) throw new Error("parameter is null")
        let obj = new MoovFile();
        try
        {
            obj.id = param.id;
            obj.customerId = param.customerId;
            obj.originalFilename = param.originalFilename;
            obj.externalFilename = param.externalFilename;
            obj.filepath = param.filepath;
            obj.lineCount = param.lineCount;
            if(param.purgeAfter) obj.purgeAfter = new Date(param.purgeAfter);
            if(param.purgedAt) obj.purgedAt = new Date (param.purgedAt);
            if(param.added) obj.added = new Date (param.added);
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:MoovFile):MoovFileDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new MoovFileDTO();
        try
        {
            dto.id = param.id;
            dto.customerId = param.customerId;
            dto.originalFilename = param.originalFilename;
            dto.externalFilename = param.externalFilename;
            dto.filepath = param.filepath;
            dto.lineCount = param.lineCount;
            if(param.purgeAfter) dto.purgeAfter = param.purgeAfter.toISOString();
            if(param.purgedAt)dto.purgedAt = param.purgedAt.toISOString();
            if(param.added)dto.added = param.added.toISOString();
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }

    get displayName(){
        return this.externalFilename?this.externalFilename:this.filepath;
    }
}